import styled, { css } from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const AdvertiseButton = styled(Button)`
  color: ${({ theme }) => theme.palette.system.blue};

  &:hover {
    background-color: ${({ theme }) => theme.palette.primary.border};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
  }
`;

export const ModalWrapper = styled.div<{ $isBottomSheet: boolean }>`
  padding: ${({ $isBottomSheet }) =>
    $isBottomSheet ? '0 0 35px 0' : '40px 50px 50px'};
`;

export const ModalHeader = styled.div<{ $isBottomSheet: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 10px;
    height: 45px;
  }

  ${({ $isBottomSheet }) =>
    $isBottomSheet &&
    css`
      margin-top: 10px;
    `}
`;

export const ModalTitle = styled(Typography.Title).attrs({ $variant: '4' })`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 16px;
    font-weight: 500;
  }
`;
